<!--
 * @Description: 客户账号详情-基本信息
 * @Author: cxh
 * @Date: 2022-05-24 15:19:34
 * @LastEditTime: 2023-03-07 15:03:26
 * @LastEditors: cxh
-->
<template>
  <a-form ref="formRef" name="advanced_search">
    <detail-card :columns="columns" :title="t('common.baseTabs')" :data="data" />
  </a-form>
</template>
<script lang="ts">
import { computed, reactive, onMounted } from 'vue'
import DetailCard from '@/components/DetailCard'
import { customerCodeDetail } from '@/api/overseasSales/customerCenter'
import { customerPhaseEnum, arkCodeStatusEnum } from '@/views/overseasSales/commonEnum/dataConfig'
import { useI18n } from 'vue-i18n'
export default { name: 'BaseMessage' }
</script>
<script setup lang="ts">
const { t } = useI18n()
const props = defineProps({
  id: {
    type: String
  }
})
const columns = computed(() => [
  { title: t('arkCode.arkCode'), dataIndex: 'arkCode' },
  {
    title: t('arkCode.stage'),
    dataIndex: 'stage',
    node: 'cos-select',
    attrs: {
      options: customerPhaseEnum
    }
  },
  { title: t('arkCode.arkAccount'), dataIndex: 'arkAccount' },
  { title: t('arkCode.level'), dataIndex: 'level' },
  { title: t('arkCode.arkContact'), dataIndex: 'arkContactName' },
  { title: t('arkCode.amount'), dataIndex: 'amount' },
  { title: t('arkCode.arkContactMobile'), dataIndex: 'arkContactMobile' },
  { title: t('common.updateTime'), dataIndex: 'updateTime' },
  { title: t('arkCode.sellerName'), dataIndex: 'sellerName' },
  { title: t('common.createTime'), dataIndex: 'createTime' },
  {
    title: t('custom.arkStatus'),
    dataIndex: 'status',
    node: 'cos-select',
    attrs: {
      options: arkCodeStatusEnum
    }
  }
])
const data = reactive({})
const fetch = () => {
  if (props.id) {
    customerCodeDetail(props.id).then((res) => {
      Object.assign(data, res.data)
    })
  }
}
onMounted(() => {
  fetch()
})
</script>
